import { trackEvent } from './utils.js';

export function addWhereToBuyForm(element) {

  if (!element) {
    return
  }

  const form = element.querySelector('form')
  const thanks = element.querySelector('.thank-you-copy')


  form.addEventListener('submit', (e) => {
    e.preventDefault()
    const formData = new FormData(form)
    post(formData)
  })

  const post = (formData) => {
    const postAddress = window.base_path + '/tools/whereToBuy?method=sign-up'
    const xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        respond(xhr)
      }
    };

    xhr.open('POST', postAddress)
    xhr.send(formData)
  }

  const respond = (response) => {
    console.log(response.responseText)

    if (response.responseText.includes('OK')) {
      thanks.classList.add('show')
      form.classList.remove('show')
      trackEvent({ type: 'where-to-buy', ev: 'sign-up', val: 'success' })
    } else {
      console.log('failed.. ')
      trackEvent({ type: 'where-to-buy', ev: 'sign-up', val: 'fail' })
    }

  }

}


// WEBPACK FOOTER //
// ./src/where-to-buy.js